<template>
  <app-card
    class="px-6 py-4 flex flex-col"
    :class="cardBorderColor"
    :status="cardType === 'withdrawn' ? cardType : 'grading'"
  >
    <div
      class="border-b border-grey-200 mb-4 pb-4 flex flex-col justify-between flex-1"
    >
      <div class="flex items-start flex-1">
        <div class="flex-1">
          <h2
            class="text-xl leading-tight"
            :class="{ 'text-grey-200': application.withdrawn_at }"
            v-html="applicationTitle(application)"
          />
          <p
            v-if="application.application"
            class="text-3xl font-bold"
            :class="cardTextColor"
          >
            {{ applicationTotalCosts(application.application) }}
          </p>
        </div>
        <card-actions>
          <ul class="list-reset text-sm text-center">
            <li v-if="hasPresentation" class="p-2">
              <a
                class="block no-underline hover:text-primary-600 text-black"
                target="_blank"
                :href="
                  route('applications.files.download', {
                    application: application.uuid,
                    file: application.presentation[0].id
                  }) + '?project=1'
                "
                >Presentation</a
              >
            </li>
            <li class="p-2">
              <a
                class="block no-underline hover:text-primary-600 text-black"
                :href="
                  route('assessments.view', { application: application.uuid })
                "
                >Review</a
              >
            </li>
            <li class="p-2">
              <a
                class="block no-underline hover:text-primary-600 text-black"
                :href="
                  route('assessments.grade', { application: application.uuid })
                "
                >Grade</a
              >
            </li>
            <li class="p-2">
              <a
                class="block no-underline hover:text-primary-600 text-black"
                :href="
                  route('applications.pdf', { application: application.uuid })
                "
                target="_blank"
                >PDF</a
              >
            </li>
            <li class="p-2 border-t border-grey-200">
              <a
                class="block no-underline hover:text-primary-600 text-black"
                :href="
                  route('applications.download', {
                    application: application.uuid
                  })
                "
                target="_blank"
                >Download</a
              >
            </li>
          </ul>
        </card-actions>
      </div>
      <div
        v-if="
          application.grading_completed ||
            application.interview_grading_completed
        "
        class="text-2xl font-bold"
        :class="
          cardType === 'withdrawn'
            ? 'text-grey-400'
            : gradingColor(gradingColorScore, 'text')
        "
      >
        <template v-if="gradingStatus === 'initial'">
          <p>
            {{ application.total }}/<small>{{ application.max_score }}</small>
          </p>
        </template>
        <template v-else-if="gradingStatus === 'interview'">
          <p>
            {{ application.interview_total }}/<small>{{
              application.max_score
            }}</small>
          </p>
        </template>
      </div>
    </div>
    <p
      class="mb-2"
      :class="{
        'text-grey-700': !application.withdrawn_at,
        'text-grey-200': application.withdrawn_at
      }"
    >
      {{ getApplicant(application.uuid, "company") | sentencecase }}
    </p>
    <p
      class="mb-2 text-sm"
      :class="{
        'text-grey-700': !application.withdrawn_at,
        'text-grey-200': application.withdrawn_at
      }"
    >
      <icon
        icon="user"
        class="w-4 h-4 icons-primary align-middle mr-2"
        :class="{ 'opacity-25': application.withdrawn_at }"
      />
      {{ getApplicant(application.uuid, "name") }}
    </p>
  </app-card>
</template>

<script>
import { gradingColourMixin } from "../../mixins/gradingColour";
export default {
  name: "UserAssessmentCard",
  mixins: [gradingColourMixin],
  props: {
    application: {
      type: Object,
      required: true
    },
    applicants: {
      type: Object,
      required: true
    },
    gradingStatus: {
      type: String,
      default() {
        return "initial";
      }
    }
  },
  computed: {
    gradingColorScore() {
      if (
        !this.application.grading_completed &&
        !this.application.interview_grading_completed
      )
        return 0;
      return Math.floor(this.application.interview_percentage / 10);
    },
    cardBorderColor() {
      if (this.cardType === "withdrawn") return;
      if (
        !this.application.grading_completed &&
        !this.application.interview_grading_completed
      )
        return "border-primary-600";
      return this.gradingColor(this.gradingColorScore, "border");
    },
    cardTextColor() {
      if (this.cardType === "withdrawn") return "text-grey-400";
      if (
        !this.application.grading_completed &&
        !this.application.interview_grading_completed
      )
        return "text-primary-600";
      return this.gradingColor(this.gradingColorScore, "text");
    },
    hasPresentation() {
      return (
        this.application.hasOwnProperty("presentation") &&
        this.application.presentation.length
      );
    },
    cardType() {
      return this.application.rejected_at
        ? "rejected"
        : this.application.withdrawn_at
        ? "withdrawn"
        : this.application.invited_at &&
          this.application.interview_grading_completed
        ? "invited"
        : "base";
    }
  },
  methods: {
    applicationTitle(application) {
      let APP = application;
      // check if UUID
      if (typeof application === "string") {
        APP = this.applications.find(application => application.uuid === APP);
      }
      if (APP.title) {
        return `[${APP.ref}] ${APP.title}`;
      } else {
        return APP.ref;
      }
    },
    applicationTotalCosts(application) {
      const app = application;
      const pl = app.lead_applicant.financial_summary.total_project_cost;
      const lead_total = pl || 0;
      let partner_costs = 0;
      if (app.project_partners) {
        partner_costs = app.project_partners.reduce((total, partner) => {
          let ptc = partner.financial_summary.total_project_cost;
          total += ptc || 0;
          return total;
        }, 0);
      }
      return (lead_total + partner_costs).toLocaleString("en-GB", {
        style: "currency",
        currency: "GBP"
      });
    },
    // Applicant Methods
    getApplicant(uuid, value) {
      return this.applicants[uuid][value];
    }
  }
};
</script>

<style></style>
